<div class="opcode-wrapper">
    <app-opcode-service-list (formEdited)="valuesChanged($event)" [saveClicked]="saveClicked"></app-opcode-service-list>
</div>